import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const HeroSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  return (
    <section className="base-section hero-section main-hp" id="HP_hero_bed">
      <Link href={tLink('bed')} noTabbing>
        <div>
          <div className="img-wrap">
            <div className="cinema-gif" id="hero-cinema-gif">
              <picture>
                <source
                  srcSet="/images/homePage/heroSection/overlay.gif"
                  media="(min-width: 661px)"
                />
                <img
                  src="/images/homePage/heroSection/fill.gif"
                  alt={tCommon('productName', { productName: t('sheratonBed') })}
                  loading="eager"
                />
              </picture>
            </div>
            <picture className="pic-background">
              <source
                srcSet="/images/homePage/heroSection/background-mob.webp"
                type="image/webp"
                media="(max-width: 660px)"
              />
              <img
                src="/images/homePage/heroSection/background.webp"
                alt={t('sheratonBed')}
                width="1440"
                height="650"
                loading="eager"
                fetchPriority="high"
              />
            </picture>
          </div>
          <div className="stack">
            <h1 className="main-section-title">{t('heroTitle')}</h1>
            <Button ariaLabel={`${tButton('shopNow')}: ${t('sheratonBed')}`}>
              {tButton('shopNow')}
            </Button>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default HeroSection;
